import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export type ToastType = "success" | "error" | "warning";

type ToastState = {
  message: string;
  type: ToastType;
  showToast: boolean;
};

@Injectable({
  providedIn: "root",
})
export class ToastService {
  private readonly toastSubject = new BehaviorSubject<ToastState>({
    message: "",
    type: "success",
    showToast: false,
  });

  readonly toast$ = this.toastSubject.asObservable();

  showToast(message: string, type: ToastType): void {
    this.toastSubject.next({ message, type, showToast: true });
    setTimeout(() => this.hideToast(), 5000);
  }

  hideToast(): void {
    this.toastSubject.next({ ...this.toastSubject.value, showToast: false });
  }
}
